import type { SelectorAutoTrigger } from '@/config/shared/auto-source';

const VALID_TRIGGERS = new Set<SelectorAutoTrigger>([
  'click',
  'submit',
  'hover',
  'visible',
]);

/**
 * Lê `data-trigger` (ou `data-track-trigger`) no elemento.
 * `null` = sem restrição (todos os modos da source).
 * Set vazio = atributo presente, mas nenhum modo válido.
 */
export function readElementTriggerModes(
  element: Element
): ReadonlySet<SelectorAutoTrigger> | null {
  const raw =
    element.getAttribute('data-trigger')?.trim() ||
    element.getAttribute('data-track-trigger')?.trim();
  if (!raw) return null;

  const modes = new Set<SelectorAutoTrigger>();
  for (const token of raw.toLowerCase().split(/[\s,]+/)) {
    if (VALID_TRIGGERS.has(token as SelectorAutoTrigger)) {
      modes.add(token as SelectorAutoTrigger);
    }
  }
  return modes;
}

export function elementAllowsTrigger(
  element: Element,
  trigger: SelectorAutoTrigger
): boolean {
  const modes = readElementTriggerModes(element);
  if (modes == null) return true;
  return modes.has(trigger);
}
